export const adminTimestatmentType = {
  dispute: 'dispute',
  attendanceConfirmed: 'attendance-confirmed',
  paid: 'paid',
};
